import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { HistorialDescargablesI } from '../../../models/descargables'
import { useState } from 'react'
import { useUserBarrilitoContext } from '../../../context/UsersBarrilitoContext'
import useFetchDescargables from '../../../hooks/useFetchDescargables'
import useFetchUsersBarrilito from '../../../hooks/useFetchUsersBarrilito'
import { formatDateHourMinute, getUserName } from '../../../utils/strings'
import { useDescargablesContext } from '../../../context/DescargablesContext'
import UIButton from '../../UI/UIButton'
import {  getHistorialDescargableAll } from '../../../services/descargables/historialDescargable'

const BtnExportHistorial = () => {

    const [loading, setLoading] = useState(false)
    const { usersBarrilito } = useUserBarrilitoContext()
    useFetchDescargables()
    useFetchUsersBarrilito()
    const { descargables } = useDescargablesContext()

    const exportToExcel = async () => {
      setLoading(true)

      const historialDescargableDB = await getHistorialDescargableAll() as HistorialDescargablesI  

      const data = (historialDescargableDB || []).map((row) => ({
        ID: row.id,
        Descargable: descargables.find((descargable) => descargable.id === row.id_descargable)?.titulo || '',
        Usuario: getUserName(usersBarrilito.find((user) => user.id === row.id_usuario)),
        'Fecha de descarga': formatDateHourMinute(row.fecha_descarga),
      }))
      
      const worksheet = XLSX.utils.json_to_sheet(data)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Historial descargas')
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
      const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' })
      const fileName = `historial_descarga.xlsx`
      saveAs(dataBlob, fileName)

      setLoading(false)
    }

  return (
    <UIButton onClick={exportToExcel} text="Descargar historial" loading={loading} />
  )
}

export default BtnExportHistorial